import uuidv4 from 'uuid/v4';
export abstract class AbstractBoardLane {
  laneId: string;
  disabled: boolean = false;

  constructor() {
    this.laneId = uuidv4();
  }
}
